import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDutyRateBasis implements BaseEnumType {
  private static allValues: EnumDutyRateBasis[] = []; // make sure this is top-most
  
  public static none = new EnumDutyRateBasis(0, "None", "enum_duty_rate_basis_none");
  public static perHectolitrePercent = new EnumDutyRateBasis(1, "PerHectolitrePercent", "enum_duty_rate_basis_per_hectolitre_percent");
  public static perHectolitreOfProduct = new EnumDutyRateBasis(2, "PerHectolitreOfProduct", "enum_duty_rate_basis_per_hectolitre_of_product");
  public static perLitreOfAlcohol = new EnumDutyRateBasis(3, "PerLitreOfAlcohol", "enum_duty_rate_basis_per_litre_of_alcohol");
  public static perLitreOfProduct = new EnumDutyRateBasis(4, "PerLitreOfProduct", "enum_duty_rate_basis_per_litre_of_product");
  public static perLitreAbv = new EnumDutyRateBasis(5, "PerLitreAbv", "enum_duty_rate_basis_per_litre_abv");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDutyRateBasis.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumDutyRateBasis.none; }
  public isPerHectolitrePercent() { return this === EnumDutyRateBasis.perHectolitrePercent; }
  public isPerHectolitreOfProduct() { return this === EnumDutyRateBasis.perHectolitreOfProduct; }
  public isPerLitreOfAlcohol() { return this === EnumDutyRateBasis.perLitreOfAlcohol; }
  public isPerLitreOfProduct() { return this === EnumDutyRateBasis.perLitreOfProduct; }
  public isPerLitreAbv() { return this === EnumDutyRateBasis.perLitreAbv; }

  public static getValues(): readonly EnumDutyRateBasis[] {
    return EnumDutyRateBasis.allValues;
  }

  public static getValuesExcept0(): readonly EnumDutyRateBasis[] {
    return EnumDutyRateBasis.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDutyRateBasis {
    const found = EnumDutyRateBasis.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDutyRateBasis - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDutyRateBasis): EnumDutyRateBasis {
    const found = name ? EnumDutyRateBasis.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDutyRateBasis - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDutyRateBasis>): boolean {
    return this.key === other?.key;
  }
}